<template>
  <div class="footer" style="background-color: #ffc400">
    <v-footer padless>
      <v-card class="flex" flat tile>
        <v-card-title class="red darken-4" style="background-color: #ffc400 !important;">
          <img
            class="ml-3"
            src="@/assets/logoBranco.png"
            alt="Brasão Prefeitura"
            width="130"/>

          <div class="flex-grow-1"></div>

          <v-btn
            v-for="link in icons"
            :key="link.icon"
            class="mx-4 hidden-xs-only"
            dark
            icon
            :href="link.pagina"
            target="_blank"
          >
            <v-icon size="24px" color="white">{{ link.icon }}</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-actions class="justify-center grey lighten-4">
          {{ new Date().getFullYear() }} —
          <span class="font-weight-light">
            IMA - Powered by IMA - Informática de Municípios Associados
          </span>
        </v-card-actions>
      </v-card>
    </v-footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      icons: [
        {
          icon: "fab fa-facebook",
          pagina: "https://pt-br.facebook.com/prefeituradecampinas",
        },
        {
          icon: "fab fa-twitter",
          pagina: "https://twitter.com/campinaspref/",
        },
        {
          icon: "fab fa-instagram",
          pagina: "https://www.instagram.com/secretariafinancas.campinas",
                   
        },
        {
          icon: "fab fa-flickr",
          pagina: "https://www.flickr.com/photos/prefeituracampinas",
        },
        {
          icon: "fab fa-youtube",
          pagina: "https://www.youtube.com/user/PrefeituradeCampinas",
        },
      ],
    };
  },
};
</script>

<style scoped></style>
